// extracted by mini-css-extract-plugin
module.exports = {"resultsCount":"AccountResultsCount_resultsCount__b15UK"};